// assets/morak-global-model.js
(function () {
  const LS_KEY = "selected_model";
  const MODEL_KEY = "filter.v.option.modelo";
  const AVAIL_KEY = "filter.v.availability";
  const HEADER_ID = "global-model-selector";

  // ------------ helpers ------------
  function norm(s) {
    return String(s || "").trim().toLowerCase().replace(/\s+/g, " ");
  }
  function getURL(href = location.href) {
    return new URL(href, location.origin);
  }
  function getSavedModel() {
    try { return localStorage.getItem(LS_KEY) || ""; } catch { return ""; }
  }
  function saveModel(label) {
    try {
      if (label) localStorage.setItem(LS_KEY, label);
      else localStorage.removeItem(LS_KEY);
    } catch {}
  }

  function isCollection() { return location.pathname.startsWith("/collections/"); }
  function isProduct() { return location.pathname.startsWith("/products/"); }

  // Preferred default Tipo de Case (raw option values)
  const CASE_TYPE_PRIORITY = [
    "Protección 5m",
    "Protección 3m - Negro",
    "Protección 3m - Blanco",
    "Protección 1.5m",
  ];

  function findCaseTypeRadios() {
    const fieldset = document.querySelector('fieldset.variant-option[data-option-name="Tipo de Case"]');
    if (!fieldset) return [];
    return Array.from(fieldset.querySelectorAll('input[type="radio"]'));
  }

  function isCaseTypeRadioAvailable(radio) {
    if (!radio) return false;
    if (radio.disabled) return false;
    if (radio.getAttribute("aria-disabled") === "true") return false;
    if (radio.dataset.optionAvailable === "false") return false;
    return true;
  }

  function hasValidCaseTypeSelected() {
    const checked = findCaseTypeRadios().find((r) => r.checked);
    return isCaseTypeRadioAvailable(checked);
  }

  function selectDefaultCaseType() {
    const radios = findCaseTypeRadios();
    if (!radios.length) return false;
    if (hasValidCaseTypeSelected()) return true;

    for (const pref of CASE_TYPE_PRIORITY) {
      const wanted = norm(pref);
      const target = radios.find(
        (r) => norm(r.value) === wanted && isCaseTypeRadioAvailable(r)
      );
      if (target) {
        if (!target.checked) {
          target.click();
          target.dispatchEvent(new Event("change", { bubbles: true }));
        }
        return true;
      }
    }

    const fallback = radios.find((r) => isCaseTypeRadioAvailable(r));
    if (fallback && !fallback.checked) {
      fallback.click();
      fallback.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }

    return false;
  }

  function scheduleDefaultCaseTypeSelection() {
    if (!isProduct()) return;
    [0, 120, 300, 600, 1000].forEach((delay) => {
      setTimeout(() => {
        if (!hasValidCaseTypeSelected()) selectDefaultCaseType();
      }, delay);
    });
  }

  function setAvailability(url) {
    if (!url.searchParams.has(AVAIL_KEY)) url.searchParams.set(AVAIL_KEY, "1");
  }

  // ------------ 1) HEADER: change -> save + apply (collection/product) ------------
  function bindHeader() {
    // Listen to ALL selectors with this ID (desktop and mobile)
    const selectors = document.querySelectorAll('#' + HEADER_ID);
    if (!selectors.length) return;

    selectors.forEach((sel, idx) => {
      const isHomePage = sel.dataset.homePage === "true";
      
      if (isHomePage) {
        // Don't touch home page selectors on load - morak-home-filter.js handles initial value
      }

      sel.addEventListener("change", () => {
        const label = (sel.value || "").trim();
        saveModel(label);

        // Sync all other selectors
        document.querySelectorAll('#' + HEADER_ID).forEach((otherSel) => {
          if (otherSel !== sel && otherSel.value !== label) {
            const opts = Array.from(otherSel.options);
            const match = opts.find(o => norm(o.value) === norm(label));
            if (match) {
              otherSel.value = match.value;
              otherSel.selectedIndex = opts.indexOf(match);
            }
          }
        });

        if (isCollection()) {
          const url = getURL();
          setAvailability(url);
          url.searchParams.delete(MODEL_KEY);
          if (label) url.searchParams.append(MODEL_KEY, label);
          // Reset pagination when model changes
          url.searchParams.delete('page');
          if (url.toString() !== location.href) location.replace(url.toString());
        }

        if (isProduct()) {
          applyModelOnProductPage();
          scheduleDefaultCaseTypeSelection();
        }
      }, true);
    });
  }

  // ------------ 2) COLECCIÓN: al entrar -> si falta modelo en URL, poner el guardado ------------
  function enforceModelOnCollectionLoad() {
    if (!isCollection()) return;

    const url = getURL();
    setAvailability(url);

    const fromUrl = url.searchParams.get(MODEL_KEY) || "";
    if (fromUrl) {
      // URL manda: lo guardamos y listo
      saveModel(fromUrl);
      return;
    }

    const saved = getSavedModel();
    if (!saved) {
      // no hay modelo global, solo asegurar availability
      if (url.toString() !== location.href) location.replace(url.toString());
      return;
    }

    url.searchParams.append(MODEL_KEY, saved);
    location.replace(url.toString());
  }

  // ------------ 2b) COLECCIÓN: interceptar clicks a otras colecciones y arrastrar modelo ------------
  function bindCollectionLinksCarryOver() {
    document.addEventListener("click", (e) => {
      const a = e.target.closest && e.target.closest("a");
      if (!a) return;

      const hrefRaw = a.getAttribute("href") || "";
      if (!hrefRaw) return;
      if (hrefRaw.startsWith("#") || hrefRaw.startsWith("mailto:") || hrefRaw.startsWith("tel:") || hrefRaw.startsWith("javascript:")) return;

      let u;
      try { u = getURL(hrefRaw); } catch { return; }

      if (u.origin !== location.origin) return;
      if (!u.pathname.startsWith("/collections/")) return;

      const saved = getSavedModel();
      setAvailability(u);

      if (saved && !u.searchParams.has(MODEL_KEY)) {
        u.searchParams.set(MODEL_KEY, saved);
      }

      // Reset pagination to page 1 when changing model
      u.searchParams.delete('page');

      e.preventDefault();
      window.location.href = u.toString();
    }, true);
  }

  // ------------ 3) PRODUCTO: cuando usuario cambia Modelo -> guardarlo ------------
  function bindProductModelChangeSave() {
    if (!isProduct()) return;

    // dropdown modelo
    const sel = document.querySelector('select[name="options[Modelo]"]');
    if (sel) {
      sel.addEventListener("change", () => {
        const label = (sel.value || "").trim();
        if (label) saveModel(label);
      }, true);
    }

    // radios modelo
    document.addEventListener("change", (e) => {
      const t = e.target;
      if (!t) return;
      if (!(t.matches && t.matches('input[type="radio"][name^="Modelo-"]'))) return;
      const label = (t.value || "").trim();
      if (label) saveModel(label);
    }, true);
  }

  // ------------ 4) PRODUCTO: aplicar modelo guardado ------------
  function applyModelOnProductPage() {
    if (!isProduct()) return;

    const saved = getSavedModel();
    if (!saved) return;

    // dropdown
    const sel = document.querySelector('select[name="options[Modelo]"]');
    if (sel) {
      const wanted = norm(saved);
      const opts = Array.from(sel.options || []);
      let target = opts.find(o => norm(o.value) === wanted) || opts.find(o => norm(o.textContent) === wanted);
      if (!target) return;

      if (target.disabled) {
        target = opts.find(o => !o.disabled && o.value);
        if (!target) return;
      }

      if (sel.value !== target.value) {
        sel.value = target.value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
        sel.dispatchEvent(new Event("input", { bubbles: true }));
      }
      scheduleDefaultCaseTypeSelection();
      return;
    }

    // radios
    const radios = Array.from(document.querySelectorAll('input[type="radio"][name^="Modelo-"]'));
    if (radios.length) {
      const wanted = norm(saved);
      let target = radios.find(r => norm(r.value) === wanted);
      if (!target) return;

      const isDisabled = target.disabled || target.getAttribute("aria-disabled") === "true";
      if (isDisabled) {
        target = radios.find(r => !r.disabled && r.getAttribute("aria-disabled") !== "true");
        if (!target) return;
      }

      if (!target.checked) {
        target.click();
        target.dispatchEvent(new Event("change", { bubbles: true }));
      }
      scheduleDefaultCaseTypeSelection();
    }
  }

  // Apply model on product pages - called IMMEDIATELY and repeatedly
  function applyProductWithRetries() {
    if (!isProduct()) return;

    // Apply MULTIPLE times to catch late-loading product forms
    const applyTimes = [0, 50, 150, 300, 500, 800];
    
    applyTimes.forEach((delay) => {
      setTimeout(() => {
        applyModelOnProductPage();
        scheduleDefaultCaseTypeSelection();
      }, delay);
    });
  }

  function bindVariantUpdateCaseTypeFallback() {
    if (!isProduct()) return;

    document.addEventListener(
      "variant:update",
      () => scheduleDefaultCaseTypeSelection(),
      true
    );
  }

  // ------------ 5) SYNC: sidebar filter changes -> update header dropdown ------------
  function bindSidebarFilterSync() {
    if (!isCollection()) return;

    // Listen for changes on Modelo filter radios in the sidebar
    document.addEventListener("change", (e) => {
      const target = e.target;
      if (!target) return;

      // Check if this is a Modelo filter radio button
      const isModeloRadio = 
        target.type === "radio" && 
        (target.name === "filter.v.option.modelo" || target.name.includes("modelo"));

      if (!isModeloRadio) return;

      // Get the selected model label
      const selectedLabel = (target.value || "").trim();
      saveModel(selectedLabel);

      // Update header dropdown
      const sel = document.getElementById(HEADER_ID);
      if (!sel) return;

      const normalized = norm(selectedLabel);
      const opts = Array.from(sel.options);
      const match = opts.find(o => norm(o.value) === normalized || norm(o.textContent) === normalized);

      if (match) {
        sel.value = match.value;
      }
    }, true);
  }

  // ------------ init ------------
  // Execute product model application IMMEDIATELY, before DOMContentLoaded
  // This prevents image flashing when coming from home page
  if (isProduct()) {
    // Try immediately
    applyProductWithRetries();
    
    // Also try when DOM is ready as backup
    document.addEventListener("DOMContentLoaded", applyProductWithRetries);
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    bindHeader();
    bindCollectionLinksCarryOver();
    bindSidebarFilterSync();
    bindVariantUpdateCaseTypeFallback();

    // colecciones: aplicar modelo global al entrar
    enforceModelOnCollectionLoad();

    // productos: guardar cambios del usuario
    bindProductModelChangeSave();
  });
})();
